import React from "react";
import {Link, useLocation} from "react-router-dom";
import {Button, Typography} from "antd";

import {paths} from "@/routes";
import PageInfoLayout from "@/components/PageInfoLayout/PageInfoLayout";

export default function InvitationAccepted(): JSX.Element {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const user = params.get("user");
  const ensemble = params.get("ensemble");
  return (
    <PageInfoLayout>
      <Typography.Title level={2}>Invitation accepted!</Typography.Title>
      {user && ensemble && (
        <Typography.Paragraph className="content">
          {user} has been successfully accepted to the ensemble {ensemble}.
        </Typography.Paragraph>
      )}
      <Link to={paths.home()}>
        <Button size="large">Go Home</Button>
      </Link>
    </PageInfoLayout>
  );
}
